import { SolutionInputModel, SolutionOutputModel } from ".";
export enum FocusedMarketStatus {
  PUBLISH = "publish",
  UNPUBLISH = "unpublish",
}

export type ImageFocusedMarketPageModel = {
  image: string | null;
};

export type FocusedMarketInputModel = Omit<
  SolutionInputModel,
  "bannerImage"
> & { featureImage: string };

export type FocusedMarketOutputModel = Omit<
SolutionOutputModel,
  "bannerImage"
> & { featureImage: string };
